import { useState } from "react";
import GenericPatientDetailsList from "../components/GenericPatientDetailsList";
import { useDispatch, useSelector } from "react-redux";
import { fetchVilUpdateRequest } from "../ipsStore/actions";
import Alert from "../../../components/Alert";

const VilPatientsList = () => {
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [refreshCallback, setRefreshCallback] = useState(null);
  const { vilUpdateResponse } = useSelector((state) => state.ips);

  const handleBulkApproval = (selectedRows, refreshFunction) => {
    const payload = {
      action: "bulk_approval",
      tr_id: selectedRows.map((row) => row.id),
    };
    dispatch(fetchVilUpdateRequest(payload));
    setRefreshCallback(() => refreshFunction);
    setShowAlert(true);
  };

  const handleAlertClose = () => {
    if (refreshCallback) {
      refreshCallback();
      setRefreshCallback(null);
    }
    setShowAlert(false);
  };

  return (
    <>
      <GenericPatientDetailsList
        header="VIL Requests"
        screen="vil_requests"
        iconUrl="/vil_requests"
        showBulkApproval={true}
        onBulkApproval={handleBulkApproval}
      />
      <Alert
        isOpen={showAlert}
        onClose={handleAlertClose}
        title="Success"
        body={vilUpdateResponse?.message}
        type="success"
        showCancelButton={false}
      />
    </>
  );
};

export default VilPatientsList;
